module.exports = __webpack_public_path__ + "static/img/005.edd74ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/005.jpg
// module id = 6GXR
// module chunks = 0